import { apiSlice } from '@/redux/api-slice'
import type {
  ProviderDelete,
  ProviderManagement,
  TransferMediaOwners,
} from './types'

export const providerManagementApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAllProviders: build.query<ProviderManagement[], void>({
      query: () => ({
        url: 'provider/getAll',
      }),
      transformResponse: (response: ProviderManagement[]) =>
        [...response].sort((a, b) =>
          a.displayName.localeCompare(b.displayName, undefined, {
            sensitivity: 'base',
          }),
        ),
      providesTags: ['Providers'],
    }),
    transferMediaOwnership: build.mutation<void, TransferMediaOwners>({
      query: (body) => ({
        url: 'provider/transferMediaOwnership',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Providers'],
    }),
    deleteProvider: build.mutation<void, ProviderDelete>({
      query: (body) => ({
        url: 'provider/deleteProvider',
        method: 'DELETE',
        body,
      }),
      invalidatesTags: ['Providers'],
    }),
  }),
})

export const {
  useGetAllProvidersQuery,
  useTransferMediaOwnershipMutation,
  useDeleteProviderMutation,
} = providerManagementApi
